import { type ContentCard } from '@braze/react-native-sdk'
import * as Braze from '@braze/web-sdk'

function getCardInstance(contentCard: ContentCard) {
  let cardInstance: Braze.Card
  switch (contentCard.type) {
    case 'Classic':
      cardInstance = new Braze.ClassicCard(
        contentCard.id,
        contentCard.viewed,
        contentCard.title,
        contentCard.image,
        contentCard.cardDescription,
        new Date(contentCard.created),
        new Date(contentCard.created),
        undefined,
        new Date(contentCard.expiresAt),
        contentCard.url,
        undefined,
        undefined,
        contentCard.extras,
        contentCard.pinned,
        contentCard.dismissible,
      )
      break
    case 'ImageOnly':
      cardInstance = new Braze.ImageOnly(
        contentCard.id,
        contentCard.viewed,
        contentCard.image,
        new Date(contentCard.created),
        new Date(contentCard.created),
        undefined,
        new Date(contentCard.expiresAt),
        contentCard.url,
        undefined,
        undefined,
        contentCard.extras,
        contentCard.pinned,
        contentCard.dismissible,
        contentCard.clicked,
      )
      break
    case 'Captioned':
      cardInstance = new Braze.CaptionedImage(
        contentCard.id,
        contentCard.viewed,
        contentCard.title,

        contentCard.image,
        contentCard.cardDescription,
        new Date(contentCard.created),
        new Date(contentCard.created),
        undefined,
        new Date(contentCard.expiresAt),
        contentCard.url,
        undefined,
        undefined,
        contentCard.extras,
        contentCard.pinned,
        contentCard.dismissible,
        contentCard.clicked,
      )
      break
    default:
      contentCard satisfies never
      // @ts-expect-error - If this is hit, the type of the content card is unhandled
      throw new Error(`Unsupported card type: ${contentCard.type}`)
  }
  cardInstance.isControl = contentCard.isControl
  return cardInstance
}

export const logImpression = (contentCard: ContentCard) => {
  Braze.logContentCardImpressions([getCardInstance(contentCard)])
}

export const logClick = (contentCard: ContentCard) => {
  Braze.logContentCardClick(getCardInstance(contentCard))
}
